import type { AnyRoute } from '@tanstack/react-router';
import { AccountShell } from '@/routes/_account';
import { AppLayout } from '@/routes/_app';
import { PublicLayout } from '@/routes/_public';
import { WorkspaceShell } from '@/routes/_workspace';
import { RootComponent } from '@/routes/__root';
import type { ShellConfig } from '../model/types';

type RouteComponent = NonNullable<AnyRoute['options']['component']>;

const shellRegistry: Readonly<Record<string, RouteComponent>> = {
  'default-root': RootComponent,
  'default-app': AppLayout,
  'default-public': PublicLayout,
  'default-account': AccountShell,
  'default-workspace': WorkspaceShell,
};

export function resolveShellConfig(config: ShellConfig) {
  return {
    root: shellRegistry['default-root']!,
    app: shellRegistry['default-app']!,
    public: resolveShell(config.public),
    account: resolveShell(config.account),
    workspace: resolveShell(config.workspace),
  };
}

function resolveShell(id: string): RouteComponent {
  const shell = shellRegistry[id];
  if (!shell) throw new Error(`Unknown shell ID: ${id}`);
  return shell;
}
